import * as React from 'react';

import './shape.scss';

type Props = {
    children?: React.ReactNode;
    className?: string;
    dataTestid?: string;
};

export default function Shape({
    children,
    className = '',
    dataTestid,
}: Readonly<Props>) {
    return (
        <div className={`shape${className}`} data-testid={dataTestid}>
            {children}
        </div>
    );
}
